import React from 'react';

import Box from '@mui/material/Box';

import { KnzComponentProps } from '../../../types';

/**
 * 読み物のテーブル（thoughts-ai の ArticleTable 相当）。紙面デザインに合わせた配色。
 * params: headers（array, `|` 区切り。空セルも許容）、text（array, 各行 `|` 区切り）
 */
const splitCells = (line: string): string[] => line.split('|').map((c) => c.trim());

export const ProseTable: React.FC<KnzComponentProps> = ({ node }) => {
  const headerRaw = node.params.headers;
  const headerLine = Array.isArray(headerRaw) ? headerRaw[0] : ((headerRaw as string) ?? '');
  const headers = headerLine !== undefined && headerLine !== '' ? splitCells(headerLine) : [];

  const rowsRaw = node.params.text;
  const rowLines: string[] = Array.isArray(rowsRaw) ? rowsRaw : rowsRaw ? [String(rowsRaw)] : [];
  const rows = rowLines.map(splitCells);

  return (
    <Box sx={{ overflowX: 'auto', my: 2 }}>
      <Box
        component="table"
        sx={{
          width: '100%',
          borderCollapse: 'collapse',
          fontFamily: '"Noto Sans JP", sans-serif',
          fontSize: 13,
          '& th, & td': {
            border: '1px solid #D0CCC5',
            p: '12px 16px',
            textAlign: 'left',
            color: '#1A1A1A',
          },
          '& th': {
            bgcolor: '#F0EDE8',
            fontWeight: 700,
          },
        }}
      >
        {headers.length > 0 && (
          <Box component="thead">
            <Box component="tr">
              {headers.map((h, i) => (
                <Box component="th" key={i}>
                  {h}
                </Box>
              ))}
            </Box>
          </Box>
        )}
        <Box component="tbody">
          {rows.map((row, r) => (
            <Box component="tr" key={r}>
              {row.map((cell, c) => (
                <Box component="td" key={c}>
                  {cell}
                </Box>
              ))}
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default ProseTable;
